import { render, staticRenderFns } from "./ContactAccessButton.vue?vue&type=template&id=3cd49b24&"
import script from "./ContactAccessButton.vue?vue&type=script&lang=js&"
export * from "./ContactAccessButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports